import React from "react";
import DistribuicoesComponent from "./components/Distribuicoes";

const Distribuicoes = () => {
  return <DistribuicoesComponent />;
};

export default Distribuicoes;
